<template>
  <v-card style="border-radius: 10px;" class="pa-1 ma-1">
    <v-list-item>
      <v-list-item-avatar>
        <v-avatar>
          <v-img contain :src="reviewer.photo || '/img/profile-default.jpg'" :alt="reviewer.name" />
        </v-avatar>
      </v-list-item-avatar>
      <p class="my-auto">{{reviewer.name}}</p>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: { reviewer: Object },
};
</script>
